/**
 * @generated SignedSource<<62d88f02abd7641b9a3a5fc3b8c7504b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AttributeType = "BOOLEAN" | "DATE" | "INTEGER" | "STRING" | "%future added value";
export type ConfigurationAttributeDefinitionsViewQuery$variables = Record<PropertyKey, never>;
export type ConfigurationAttributeDefinitionsViewQuery$data = {
  readonly attributeDefinitions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityTypes: ReadonlyArray<string>;
        readonly id: string;
        readonly label: string;
        readonly name: string;
        readonly type: AttributeType;
      } | null | undefined;
    }>;
  };
};
export type ConfigurationAttributeDefinitionsViewQuery = {
  response: ConfigurationAttributeDefinitionsViewQuery$data;
  variables: ConfigurationAttributeDefinitionsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AttributeDefinitionConnection",
    "kind": "LinkedField",
    "name": "attributeDefinitions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AttributeDefinitionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AttributeDefinition",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "label",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entityTypes",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConfigurationAttributeDefinitionsViewQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ConfigurationAttributeDefinitionsViewQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "75a975751bd8d8e5be38fdede15c5a5e",
    "id": null,
    "metadata": {},
    "name": "ConfigurationAttributeDefinitionsViewQuery",
    "operationKind": "query",
    "text": "query ConfigurationAttributeDefinitionsViewQuery {\n  attributeDefinitions {\n    edges {\n      node {\n        id\n        name\n        label\n        type\n        entityTypes\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4d63f2e59331ae3a9604317a2cdaa140";

export default node;
